import SubscribeForm from "@/components/feature/SubscribeForm";
import SectionHeading from "@/components/feature/SectionHeading";

const features = [
  { icon: "ri-flashlight-line", text: "最新章节第一时间推送" },
  { icon: "ri-inbox-line", text: "多部作品集中管理" },
  { icon: "ri-refund-2-line", text: "完全免费 · 随时可退订" },
];

export default function SubscribeSection() {
  return (
    <section
      id="subscribe"
      className="relative scroll-mt-16 overflow-hidden bg-gradient-to-br from-primary-700 via-primary-800 to-secondary-900 py-16 md:py-24"
    >
      <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-accent-500/20 blur-3xl" />
      <div className="pointer-events-none absolute -left-16 bottom-0 h-72 w-72 rounded-full bg-background-50/10 blur-2xl" />

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <SectionHeading
            light
            eyebrow="追更提醒"
            title="订阅后，最新章节不再错过"
            desc="留下你的邮箱并选择想追的作品，更新第一时间推送到你手中，追更体验顺畅高效。"
          />
          <div className="mx-auto mb-8 flex flex-wrap items-center justify-center gap-3">
            {features.map((f) => (
              <span
                key={f.text}
                className="flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-2 text-sm text-background-50"
              >
                <i className={`${f.icon} text-accent-400`} aria-hidden="true" />
                {f.text}
              </span>
            ))}
          </div>
          <SubscribeForm />
        </div>
      </div>
    </section>
  );
}